import { render, staticRenderFns } from "./HistoryMessages.vue?vue&type=template&id=913c9956"
import script from "./HistoryMessages.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryMessages.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports